import { images } from '../constants';

const services = [
    {
        id: 1,
        image: images.service1,
        title: 'Installation Services',
        content: 'Professional installation of high-quality locks, doors, and windows to enhance the safety and functionality of your property.',
        paragraphs: [
            'Upgrade your security with our professional installation services. We provide expert installation of high-quality locks, doors, and windows to safeguard your property and belongings.',
            'Our experienced team ensures precise installation, offering peace of mind and enhanced protection for your home or business.'
        ],
        gallery: [
            images.service1Gallery1,
            images.service1Gallery2
        ],
        features: [
            'High-Quality Products',
            'Professional Installation',
            'Enhanced Security',
            'Customized Solutions',
            'Expert Advice'
        ],
        procedure: [
            'Security Assessment',
            'Product Selection',
            'Professional Installation',
            'Testing and Verification',
            'Client Satisfaction'
        ],
        faqs: [
            {
                id: 1,
                heading: 'How long does installation take?',
                content: 'The duration of installation depends on factors such as the type of product and the complexity of the installation. Our team strives to complete installations efficiently while maintaining quality.'
            },
            {
                id: 2,
                heading: 'Can you install products on all types of surfaces?',
                content: 'Yes, we provide installation services for a wide range of surfaces, including wood, metal, concrete, and more.'
            },
            {
                id: 3,
                heading: 'Do you offer warranty for installations?',
                content: 'We stand behind the quality of our workmanship and offer warranties for installations. Please contact us for more details about our warranty terms.'
            },
            {
                id: 4,
                heading: 'What types of products do you install?',
                content: 'We install a variety of products, including locks, doors, windows, and more. Our team can recommend the most suitable products based on your specific needs.'
            }
        ]
    },
    {
    id: 2,
    image: images.service2,
    title: 'Repair Services',
    content: 'Expert repair services to fix issues with windows and doors, ensuring proper functionality and security.',
    paragraphs: [
        'Restore the safety and performance of your windows and doors with our reliable repair services. We address a wide range of issues, from damaged locks and broken hinges to warped frames and seal failures.',
        'Our skilled technicians provide efficient and long-lasting repairs, using quality materials and tools to ensure optimal results and enhanced security for your property.'
    ],
    gallery: [
        images.service2Gallery1,
        images.service2Gallery2
    ],
    features: [
        'Prompt and Reliable Service',
        'Trained Repair Technicians',
        'Fixes for Various Window & Door Types',
        'Restored Functionality',
        'Improved Security'
    ],
    procedure: [
        'Damage Assessment',
        'Diagnosis and Planning',
        'On-Site Repair Execution',
        'Testing for Proper Function',
        'Final Quality Check'
    ],
    faqs: [
        {
            id: 1,
            heading: 'What types of repairs do you handle?',
            content: 'We handle repairs for locks, hinges, handles, frames, seals, and more across all types of windows and doors.'
        },
        {
            id: 2,
            heading: 'Do I need to replace the entire window or door?',
            content: 'Not always. Many issues can be resolved with repairs. Our team will assess the damage and recommend the most cost-effective solution.'
        },
        {
            id: 3,
            heading: 'How long does a typical repair take?',
            content: 'Most repairs are completed within a few hours, depending on the complexity of the issue and availability of parts.'
        },
        {
            id: 4,
            heading: 'Do your repair services come with a warranty?',
            content: 'Yes, we provide a warranty on all repair work to ensure your peace of mind and satisfaction.'
        }
    ]
},
{
    id: 3,
    image: images.service3,
    title: 'Replacement Services',
    content: 'Efficient replacement services for windows and doors, restoring their functionality and appearance.',
    paragraphs: [
        'When repairs aren’t enough, our expert replacement services ensure your windows and doors are restored with modern, secure, and energy-efficient options. We replace worn-out or outdated components with precision and care.',
        "Whether it's due to damage, wear and tear, or design upgrades, we offer tailored replacement solutions that match your property's style and meet current safety standards."
    ],
    gallery: [
        images.service3Gallery1,
        images.service3Gallery2
    ],
    features: [
        'High-Quality Replacement Products',
        'Precise Measurements and Fit',
        'Enhanced Energy Efficiency',
        'Improved Aesthetic Appeal',
        'Expert Craftsmanship'
    ],
    procedure: [
        'Initial Assessment & Recommendations',
        'Product Selection and Customization',
        'Removal of Old Units',
        'Professional Replacement Installation',
        'Final Inspection and Clean-Up'
    ],
    faqs: [
        {
            id: 1,
            heading: 'When should I consider replacing my windows or doors?',
            content: 'If your windows or doors are drafty, hard to operate, or visibly damaged, replacement may be a better long-term solution than repair.'
        },
        {
            id: 2,
            heading: 'Do you offer energy-efficient replacements?',
            content: 'Yes, we provide a variety of energy-efficient doors and windows that help reduce energy costs and improve comfort.'
        },
        {
            id: 3,
            heading: 'Can you match the style of my existing windows and doors?',
            content: 'Absolutely. We offer customizable options to closely match your existing design or upgrade to a new aesthetic.'
        },
        {
            id: 4,
            heading: 'How long does the replacement process take?',
            content: 'Most replacements are completed within a day, but timing may vary depending on the scope of the project and number of units being replaced.'
        }
    ]
},
{
    id: 4,
    image: images.service4,
    title: 'Consultation Services',
    content: 'Professional consultation services to provide expert advice and recommendations on windows and doors.',
    paragraphs: [
        'Our consultation services are designed to help you make informed decisions about your windows and doors. Whether you’re planning a new installation, replacement, or upgrade, we provide expert insights tailored to your specific needs.',
        'From product recommendations to design considerations and security enhancements, our specialists guide you through every option to ensure the best outcome for your home or business.'
    ],
    gallery: [
        images.service4Gallery1,
        images.service4Gallery2
    ],
    features: [
        'Personalized Guidance',
        'Comprehensive Assessments',
        'Product & Design Recommendations',
        'Security & Efficiency Advice',
        'Transparent Communication'
    ],
    procedure: [
        'Initial Client Meeting',
        'On-Site Assessment (if needed)',
        'Needs Analysis & Objective Setting',
        'Product & Design Recommendations',
        'Follow-Up Support & Planning'
    ],
    faqs: [
        {
            id: 1,
            heading: 'What does your consultation service include?',
            content: 'It includes a detailed discussion about your needs, on-site assessment if necessary, and tailored recommendations for products, design, and security upgrades.'
        },
        {
            id: 2,
            heading: 'Is there a fee for the consultation?',
            content: 'Some consultations are free, especially when bundled with installation or replacement services. Please contact us for specific pricing details.'
        },
        {
            id: 3,
            heading: 'Do you help with product selection?',
            content: 'Yes, we offer expert advice on selecting the best doors and windows based on your property type, style preferences, and budget.'
        },
        {
            id: 4,
            heading: 'Can I schedule a consultation online?',
            content: 'Absolutely. You can schedule a consultation through our website or by contacting our customer support team.'
        }
    ]
},
{
    id: 5,
    image: images.service5,
    title: 'Customization Services',
    content: 'Customization services to design and create unique windows and doors according to your preferences.',
    paragraphs: [
        'Elevate your space with our customization services, where your vision meets expert craftsmanship. We design and build bespoke windows and doors that perfectly match your style, functional needs, and architectural requirements.',
        'From material selection to color, size, and design details, our team collaborates closely with you to bring your ideas to life. Whether it’s for residential or commercial use, we ensure every customized solution reflects quality and individuality.'
    ],
    gallery: [
        images.service5Gallery1,
        images.service5Gallery2
    ],
    features: [
        'Tailored Design Solutions',
        'Wide Range of Materials',
        'Precise Craftsmanship',
        'Style & Functionality Blend',
        'Client-Centric Approach'
    ],
    procedure: [
        'Client Consultation & Requirement Gathering',
        'Concept Design & Approval',
        'Material & Component Selection',
        'Custom Fabrication',
        'Final Installation & Finishing'
    ],
    faqs: [
        {
            id: 1,
            heading: 'Can I choose my own design for doors and windows?',
            content: 'Yes, our customization services allow you to fully personalize the design, including size, material, color, and other features.'
        },
        {
            id: 2,
            heading: 'How long does customization take?',
            content: 'The timeline depends on the complexity of your design and material availability, but we strive to deliver within agreed timeframes without compromising quality.'
        },
        {
            id: 3,
            heading: 'Are customized products covered by warranty?',
            content: 'Yes, we offer warranties on all customized doors and windows, ensuring quality and customer satisfaction.'
        },
        {
            id: 4,
            heading: 'Do you assist with design ideas?',
            content: 'Absolutely. Our experts are here to guide you through the design process and offer recommendations that align with your preferences and space.'
        }
    ]
},
{
    id: 6,
    image: images.service6,
    title: 'Maintenance Services',
    content: 'Regular maintenance services to keep your windows and doors in optimal condition, ensuring longevity and performance.',
    paragraphs: [
        'Protect your investment with our comprehensive maintenance services for windows and doors. We help prevent wear and tear, address minor issues early, and ensure everything functions smoothly year-round.',
        'Our team performs routine checks, adjustments, and cleaning to enhance durability, efficiency, and security. Whether residential or commercial, our maintenance plans are designed to extend the life of your installations and maintain their appearance.'
    ],
    gallery: [
        images.service6Gallery1,
        images.service6Gallery2
    ],
    features: [
        'Scheduled Maintenance Plans',
        'Thorough Inspection & Cleaning',
        'Lubrication of Moving Parts',
        'Minor Repairs & Adjustments',
        'Performance Optimization'
    ],
    procedure: [
        'Initial Assessment & Condition Report',
        'Cleaning & Lubrication of Components',
        'Tightening & Realignment',
        'Repair of Minor Damages',
        'Final Review & Client Feedback'
    ],
    faqs: [
        {
            id: 1,
            heading: 'How often should I schedule maintenance?',
            content: 'We recommend bi-annual or annual maintenance depending on usage and environmental exposure to ensure consistent performance.'
        },
        {
            id: 2,
            heading: 'What’s included in the maintenance service?',
            content: 'Our service includes inspections, lubrication, minor repairs, cleaning, and adjustments to ensure optimal function and longevity.'
        },
        {
            id: 3,
            heading: 'Do you offer maintenance packages?',
            content: 'Yes, we offer flexible maintenance packages tailored to residential or commercial needs, ensuring peace of mind all year round.'
        },
        {
            id: 4,
            heading: 'Can maintenance prevent major repairs?',
            content: 'Absolutely. Regular maintenance helps catch small issues before they escalate, potentially saving you from costly repairs or replacements.'
        }
    ]
}






];

export default services;